import OrderStates from './OrderStates'

export default OrderStates;


// WEBPACK FOOTER //
// ./src/components/Query/OrderStates/index.ts